 
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const getColor = (value, index, colors) => {
  if (index <= value) {
    return colors[0];
  } else {
    return colors[1];
  }
};

const ProficencySvg = ({ value, colors }) => (
  <svg
    width="72"
    height="6"
    viewBox="0 0 72 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="6" rx="3" fill={getColor(value, 1, colors)} />
    <rect
      x="18"
      width="16"
      height="6"
      rx="3"
      fill={getColor(value, 2, colors)}
    />
    <rect
      x="37"
      width="16"
      height="6"
      rx="3"
      fill={getColor(value, 3, colors)}
    />
    <rect
      x="56"
      width="16"
      height="6"
      rx="3"
      fill={getColor(value, 4, colors)}
    />
  </svg>
);

const ProficiencyBar = ({ value, title, colors = ["#4EBEEB", "#747480"] }) => (
  <>
    <ProficencySvg value={value} colors={colors} /> {title}
  </>
);

const ProficiencyLevelBar = ({ type, proficiencyLevel }) => {
  const { t } = useTranslation();
  if (type == "proficiencyLevel") {
    return (
      <ProficiencyBar
        value={proficiencyLevel}
        title={t("dashboardScreen.you")}
      />
    );
  }
  if (type == "proficiencyLevelTarget") {
    return (
      <ProficiencyBar
        value={proficiencyLevel}
        title={t("dashboardScreen.target")}
        colors={["#FF810A", "#747480"]}
      />
    );
  }
  if (type == "proficiencyLevelPeers") {
    return (
      <ProficiencyBar
        value={proficiencyLevel}
        title={t("dashboardScreen.peers")}
        colors={["#EAEAF2", "#747480"]}
      />
    );
  }
  return null;
};

ProficiencyLevelBar.propTypes = {
  type: PropTypes.oneOf([
    "proficiencyLevel",
    "proficiencyLevelTarget",
    "proficiencyLevelPeers",
  ]),
  titlePosition: PropTypes.oneOf(["left", "right"]),
  value: PropTypes.any,
};

export default ProficiencyLevelBar;
